import { config } from '@abyss/web/tools/config';

import { ConstantsLagoon } from '../../common/ConstantsLagoon';
import { useCustomQuery } from '../useCustomQuery';
import { useFeatureFlag } from '../useFeatureFlag';
import GetLocation from './Location.graphql';

export const useLocation = (options) => {
  const [isAWSLocationSearchEnabled] = useFeatureFlag([
    ConstantsLagoon.FEATURE_FLAGS.SWITCH_TO_AWS_LOCATION_SEARCH,
  ]);

  const [queryResult, queryAction] = useCustomQuery(GetLocation, {
    url: config('GRAPHQL_API_URL'),
    accessor: 'location',
    ...options,
  });

  const parsedResult = (params) =>
    queryAction({
      ...params,
      variables: {
        ...params?.variables,
        isAWSLocationSearchEnabled,
      },
    });

  return [queryResult, parsedResult];
};
